// /**
//  * FacebookEventApi v2.2.0 | (c) 2022 by shen
//  * 增加電話
//  * @param pixel
//  * @param hash
//  * @param domain
//  * @constructor
//  */
// // import $ from 'jquery'


// // const $ = require('jquery');

// var FacebookEventApi = function (pixel, hash, domain = "") {
//     // console.log(domain, 'domain');
//     // console.log(1);
//     //DEBUG 記得切換成0 不重複觸發的天數
//     var EXPIRES_DAY = 2;
//     var self = this;
//     var BASE_URL = "/api0/api/fb-event/post-data/";

//     self.fb_st = {};
//     self.pixel = pixel;
//     self.hash = hash;
//     self.domain = domain;
//     if (!pixel) {
//         pixel = "xxxxxxxx"
//     }

//     function postConvert(action, data = {}, cb = () => {}) {
//         if (pixel === "" || hash === "") {
//             console.log("FB EVENT FAIL");
//             cb();
//             return;
//         }
//         var c = $.cookie(`fb_${action}${self.pixel}`);
//         if (!c && !self.fb_st[action]) {
//             self.fb_st[action] = FacebookEventApi.makeid(10);
//             var post_data = {
//                 "fb-token": self.hash = hash,
//                 "domain": self.domain,
//                 "evend_id": self.fb_st[action],
//                 //   "currency": data.currency ? data.currency : "TWD",
//                 "value": data.total ? data.total : null,
//                 //   "customer_data" : data
//             };

//             Object.keys(data).forEach((key) => {
//                 if (data[key]) {
//                     post_data[key] = data[key];
//                 }
//             });
//             $.post(`${BASE_URL}${self.pixel}/${action}`, post_data, function (r) {
//                 $.cookie(`fb_${action}${self.pixel}`, self.fb_st[action], {
//                     expires: EXPIRES_DAY
//                 });
//                 setTimeout(function () {
//                     cb(r);
//                 }, 200);
//                 console.log("CV ${action} OK " + r["fbtrace_id"]);
//                 fbq('track', action, post_data, {
//                     eventID: self.fb_st[action]
//                 });
//             }, "json");
//         } else {
//             console.log("ARY PV:" + c);
//             cb();
//         }
//     } /**/
//     /**
//      * 觸發 pageView事件
//      */
//     self.callPageView = function () {
//         // console.log('pageView');
//         try {
//             postConvert("PageView");
//         } catch (e) {
//             console.log(e);
//             console.log("PageView error catch");
//         }
//         // var c = $.cookie(`fb_PageView${self.pixel}`);
//         // if (!c && !self.fb_st["PageView2"]) {
//         //     self.fb_st["PageView2"] = FacebookEventApi.makeid(10);
//         //     $.post(`/api/fb-event/post-data/${self.pixel}/PageView`, {
//         //         "fb-token": self.hash = hash,
//         //         "domain": self.domain,
//         //         "evend_id": self.fb_st["PageView2"]
//         //     }, function (r) {
//         //         //$.cookie('fb_PageView', self.fb_st["PageView2"], {expires: EXPIRES_DAY});
//         //         $.cookie(`fb_PageView${self.pixel}`, self.fb_st["PageView2"], {expires: EXPIRES_DAY});
//         //         setTimeout(function () {
//         //             console.log("PX PV OK " + r["fbtrace_id"]);
//         //             fbq('track', 'PageView', '', {eventID: self.fb_st["PageView2"]});
//         //         }, 1500);
//         //     }, "json");
//         // } else {
//         //     console.log("ARY PV:" + c);
//         // }
//     }

//     self.callAddToCart = function () {
//         try {
//             postConvert("AddToCart");
//         } catch (e) {
//             console.log("AddToCart error catch");
//         }
//     }
//     /**
//      * 加入購物車觸發事件第二版 優先建議使用
//      * @param content_ids  與事件相關的產品編號，例如: 'JES515'，會再方法裡面自動進行組裝 SKU。
//      * @param content_name  頁面／產品名稱。
//      * @param contents_quantity  內含數量
//      * @param value 金額
//      * @param currency 幣別
//      */
//     self.callAddToCart2 = function (content_ids, content_name, contents_quantity, value, currency = "TWD") {
//         var post_data = {
//             content_ids: content_ids,
//             content_name: content_name,
//             content_type: "product",
//             contents: [{
//                 'id': content_ids,
//                 'quantity': contents_quantity
//             }],
//             value: value,
//             currency: currency
//         };
//         try {
//             postConvert("AddToCart", post_data);
//         } catch (e) {
//             console.log("AddToCart2 error catch");
//         }
//         // var c = $.cookie(`fb_AddToCart2${self.pixel}`);
//         // if (!c && !self.fb_st["AddToCart2"]) {
//         //     self.fb_st["AddToCart2"] = FacebookEventApi.makeid(10);
//         //     $.post(`/api/fb-event/post-data/${self.pixel}/AddToCart`, {
//         //         "fb-token": self.hash = hash,
//         //         "domain": self.domain,
//         //         "evend_id": self.fb_st["fb_AddToCart2"]
//         //     }, function (r) {
//         //         $.cookie(`fb_AddToCart2${self.pixel}`, self.fb_st["AddToCart2"], {expires: EXPIRES_DAY});
//         //         console.log("PX ATC OK " + self.fb_st["AddToCart2"]);
//         //         try {
//         //             fbq('track', 'AddToCart', '', {eventID: self.fb_st["fb_AddToCart2"]});
//         //         } catch (e) {
//         //             console.log("callPurchase fail")
//         //         }
//         //     }, "json");
//         // } else {
//         //     console.log("ARY ATC:" + c);
//         // }
//     }


//     /**
//      *
//      * @param callBack 完成回調
//      * @param r2 total(結帳金額)
//      */
//     self.callPurchase = function (callBack, r2) {

//         var c = $.cookie(`fb_Purchase${self.pixel}`);
//         if (!c && !self.fb_st["Purchase2"]) {
//             self.fb_st["Purchase2"] = FacebookEventApi.makeid(10);
//             $.post(`/api/fb-event/post-data/${self.pixel}/Purchase`, {
//                 "fb-token": self.hash = hash,
//                 "domain": self.domain,
//                 "evend_id": self.fb_st["Purchase2"],
//                 "currency": "TWD",
//                 "value": r2.total,
//             }, function (r) {
//                 console.log("PX PC OK " + r["fbtrace_id"])
//                 $.cookie(`fb_Purchase${self.pixel}`, self.fb_st["Purchase2"], {
//                     expires: EXPIRES_DAY
//                 });
//                 try {
//                     fbq('track', 'Purchase', {
//                         "currency": "TWD",
//                         "value": r2.total
//                     }, {
//                         eventID: self.fb_st["Purchase2"]
//                     });
//                 } catch (e) {
//                     console.log("callPurchase fail")
//                 }
//                 callBack(r);
//             }, "json");
//         } else {
//             console.log("ARY PCH:" + c);
//         }
//     }


//     /**
//      *  結帳觸發第二版 優先建議使用
//      * @param callBack  完成後回調的API 異步回調
//      * @param content_ids 與事件相關的產品編號，例如: 'JES515'，會再方法裡面自動進行組裝 SKU。
//      * @param content_name 頁面／產品名稱。
//      * @param num_items 初始化結帳的項目數量。
//      * @param contents 內含數量
//      * @param value 金額(總額)
//      * @param phone 電話
//      * @param currency 幣別
//      */
//     self.callPurchase2 = function (callBack, content_ids, content_name, num_items, contents, value, phone, currency = "TWD") {
//         var post_data = {
//             content_ids: content_ids,
//             content_name: content_name,
//             content_type: "product",
//             // contents:[{'id': content_ids, 'quantity': contents_quantity}],
//             contents: contents,
//             num_items: num_items,
//             value: value,
//             currency: currency,
//             phone: phone,
//             ph: phone
//         };
//         try {
//             postConvert("Purchase", post_data, callBack);
//         } catch (e) {
//             console.log("Purchase2 error catch");
//         }


//     }

//     self.callInitiateCheckout = function () {
//         var c = $.cookie(`fb_InitiateCheckout2${self.pixel}`);
//         if (!c && !self.fb_st["InitiateCheckout2"]) {
//             self.fb_st["InitiateCheckout2"] = FacebookEventApi.makeid(10);
//             $.post(`/api/fb-event/post-data/${self.pixel}/InitiateCheckout`, {
//                 "fb-token": self.hash = hash,
//                 "domain": self.domain,
//                 "evend_id": self.fb_st["InitiateCheckout2"]
//             }, function (r) {
//                 $.cookie(`fb_InitiateCheckout2${self.pixel}`, self.fb_st["InitiateCheckout2"], {
//                     expires: EXPIRES_DAY
//                 });
//                 console.log("PX ATC OK " + self.fb_st["InitiateCheckout2"]);
//                 try {
//                     fbq('track', 'InitiateCheckout', '', {
//                         eventID: self.fb_st["fb_InitiateCheckout2"]
//                     });
//                 } catch (e) {
//                     console.log("InitiateCheckout fail")
//                 }
//             }, "json");
//         } else {
//             console.log("ARY ATC:" + c);
//         }
//     }

//     /**
//      * 開始結帳(進入結帳流程觸發的事件)
//      * @param callBack
//      * @param content_ids  與事件相關的產品編號，例如: 'JES515'，會再方法裡面自動進行組裝 SKU。
//      * @param num_items 初始化結帳的項目數量。
//      * @param contents_quantity 內含數量
//      * @param value 金額(總額)
//      * @param content_category  頁面／產品類別。
//      * @param currency 幣別
//      */
//     self.callInitiateCheckout2 = function (callBack, content_ids, num_items, contents_quantity, value, content_category = "ALL", currency = "TWD") {
//         var post_data = {
//             content_ids: [content_ids],
//             content_category: content_category,
//             contents: [{
//                 'id': content_ids,
//                 'quantity': contents_quantity
//             }],
//             value: value,
//             num_items: num_items,
//             currency: currency
//         };
//         try {
//             postConvert("Purchase", post_data);
//         } catch (e) {
//             console.log("Purchase2 error catch");
//         }
//     }

//     self.callAddPaymentInfo = function () {
//         var c = $.cookie(`fb_AddPaymentInfo2${self.pixel}`);
//         if (!c && !self.fb_st["AddPaymentInfo2"]) {
//             self.fb_st["AddPaymentInfo2"] = FacebookEventApi.makeid(10);
//             $.post(`/api/fb-event/post-data/${self.pixel}/AddPaymentInfo`, {
//                 "fb-token": self.hash = hash,
//                 "domain": self.domain,
//                 "evend_id": self.fb_st["AddPaymentInfo2"]
//             }, function (r) {
//                 $.cookie(`fb_AddPaymentInfo2${self.pixel}`, self.fb_st["AddPaymentInfo2"], {
//                     expires: EXPIRES_DAY
//                 });
//                 console.log("PX ATC OK " + self.fb_st["AddPaymentInfo2"]);
//                 try {
//                     fbq('track', 'AddPaymentInfo', '', {
//                         eventID: self.fb_st["fb_AddPaymentInfo2"]
//                     });
//                 } catch (e) {
//                     console.log("AddPaymentInfo fail")
//                 }
//             }, "json");
//         } else {
//             console.log("ARY ATC:" + c);
//         }
//     }

//     FacebookEventApi.makeid = function (length) {
//         var result = '';
//         var characters = 'ABCDEFGHIJKLMNOPQRSTSvU13Bhk3xtVY6mqr46q9sUnL9FhDZXNk456789!_#$%^&*';
//         var charactersLength = characters.length;
//         for (var i = 0; i < length; i++) {
//             result += characters.charAt(Math.floor(Math.random() *
//                 charactersLength));
//         }
//         return result;
//     }

//     self.init = function (pixel) {
//         if (!window.fbq) {
//             var script = document.createElement("script");
//             // 为脚本元素添加一个唯一的id，这样我们就可以检查它是否已经存在
//             var script = document.createElement("script");
//             script.innerHTML = `   !function(f,b,e,v,n,t,s)
//         {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
//             n.callMethod.apply(n,arguments):n.queue.push(arguments)};
//             if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
//             n.queue=[];t=b.createElement(e);t.async=!0;
//             t.src=v;s=b.getElementsByTagName(e)[0];
//             s.parentNode.insertBefore(t,s)}(window, document,'script',
//         'https://connect.facebook.net/en_US/fbevents.js');
//         fbq('init', '${pixel}');
//         `;
//             document.head.appendChild(script);
//             var noscript1 = document.createElement("noscript");
//             noscript1.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${pixel}&ev=PageView&noscript=1"/>`;
//             document.body.appendChild(noscript1);
//         }
//     }
//     self.init(pixel);

// }

// module.exports = FacebookEventApi;





/**
 * FacebookEventApi v2.2.0 | (c) 2022 by shen
 * 增加電話
 * @param pixel
 * @param hash
 * @param domain
 * @constructor
 */
var FacebookEventApi = function (pixel, hash, domain = "") {
    // console.log(1);
    //DEBUG 記得切換成0 不重複觸發的天數
    var EXPIRES_DAY = 2;
    var self = this;
    var BASE_URL = "/api0/api/fb-event/post-data/";

    self.fb_st = {};
    self.pixel = pixel;
    self.hash = hash;
    self.domain = domain;
    if (!pixel) {
        pixel = "xxxxxxxx";
    }

    function getCookie(cname) {
        var name = cname + "=";
        var decodedCookie;
        // 使用 try...catch 来处理 decodeURIComponent 可能抛出的异常
        try {
            decodedCookie = decodeURIComponent(document.cookie);
        } catch (e) {
            console.error("解码 cookie 失败：", e.message);
            decodedCookie = document.cookie; // 继续使用未解码的 cookie 字符串
        }
        // var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }


    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function postConvert(action, data = {}, cb = () => {}) {
        if (pixel === "" || hash === "") {
            console.log("FB EVENT FAIL");
            cb();
            return;
        }
        var c = getCookie(`fb_${action}${self.pixel}`);
        if (!c && !self.fb_st[action]) {
            self.fb_st[action] = FacebookEventApi.makeid(10);
            var post_data = {
                "fb-token": self.hash = hash,
                "domain": self.domain,
                "evend_id": self.fb_st[action],
                "value": data.total ? data.total : null,
            };

            Object.keys(data).forEach((key) => {
                if (data[key]) {
                    post_data[key] = data[key];
                }
            });

            var xhr = new XMLHttpRequest();
            xhr.open("POST", `${BASE_URL}${self.pixel}/${action}`, true);
            xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4 && xhr.status === 200) {
                    var r = JSON.parse(xhr.responseText);
                    setCookie(`fb_${action}${self.pixel}`, self.fb_st[action], EXPIRES_DAY);
                    setTimeout(function () {
                        cb(r);
                    }, 200);
                    console.log(`CV ${action} OK ` + r["fbtrace_id"]);
                    fbq('track', action, post_data, {
                        eventID: self.fb_st[action]
                    });
                }
            };
            xhr.send(JSON.stringify(post_data));
        } else {
            console.log("ARY PV:" + c);
            cb();
        }
    }
    self.fbgetCookie = function (cname) {
        var name = cname + "=";
        var decodedCookie;
        // 使用 try...catch 来处理 decodeURIComponent 可能抛出的异常
        try {
            decodedCookie = decodeURIComponent(document.cookie);
        } catch (e) {
            // console.error("解码 cookie 失败：", e.message);
            decodedCookie = document.cookie; // 继续使用未解码的 cookie 字符串
        }
        // var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }
    self.callPageView = function (em, phone, fn, external_id,fbclid) {
        var post_data = {
            em: em,
            phone: phone,
            fn: fn,
            external_id: external_id,
            fbclid: fbclid
        }
        try {
            postConvert("PageView",post_data);
        } catch (e) {
            console.log("PageView error catch");
        }
    }

    self.callAddToCart = function () {
        try {
            postConvert("AddToCart");
        } catch (e) {
            console.log("AddToCart error catch");
        }
    }

    self.callAddToCart2 = function (content_ids, content_name, contents_quantity, value,em, phone, fn, external_id,fbclid,  currency = "TWD") {
        var post_data = {
            content_ids: content_ids,
            content_name: content_name,
            content_type: "product",
            contents: [{
                'id': content_ids,
                'quantity': contents_quantity
            }],
            value: value,
            currency: currency,
            em: em,
            phone: phone,
            fn: fn,
            external_id: external_id,
            fbclid: fbclid
        };
        try {
            postConvert("AddToCart", post_data);
        } catch (e) {
            console.log("AddToCart2 error catch");
        }
    }

    self.callPurchase = function (callBack, r2) {
        var c = getCookie(`fb_Purchase${self.pixel}`);
        if (!c && !self.fb_st["Purchase2"]) {
            self.fb_st["Purchase2"] = FacebookEventApi.makeid(10);
            var xhr = new XMLHttpRequest();
            xhr.open("POST", `/api/fb-event/post-data/${self.pixel}/Purchase`, true);
            xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4 && xhr.status === 200) {
                    var r = JSON.parse(xhr.responseText);
                    console.log("PX PC OK " + r["fbtrace_id"]);
                    setCookie(`fb_Purchase${self.pixel}`, self.fb_st["Purchase2"], EXPIRES_DAY);
                    try {
                        fbq('track', 'Purchase', {
                            "currency": "TWD",
                            "value": r2.total
                        }, {
                            eventID: self.fb_st["Purchase2"]
                        });
                    } catch (e) {
                        console.log("callPurchase fail");
                    }
                    callBack(r);
                }
            };
            xhr.send(JSON.stringify({
                "fb-token": self.hash = hash,
                "domain": self.domain,
                "evend_id": self.fb_st["Purchase2"],
                "currency": "TWD",
                "value": r2.total,
            }));
        } else {
            console.log("ARY PCH:" + c);
        }
    }

    self.callPurchase2 = function (callBack, content_ids, content_name, num_items, contents, value, em, phone, fn, external_id,fbclid, currency = "TWD") {
        var post_data = {
            content_ids: content_ids,
            content_name: content_name,
            content_type: "product",
            contents: contents,
            num_items: num_items,
            value: value,
            currency: currency,
            em: em,
            phone: phone,
            fn: fn,
            external_id: external_id,
            fbclid: fbclid
        };
        try {
            postConvert("Purchase", post_data, callBack);
        } catch (e) {
            console.log("Purchase2 error catch");
        }
    }

    self.callInitiateCheckout = function () {
        var c = getCookie(`fb_InitiateCheckout2${self.pixel}`);
        if (!c && !self.fb_st["InitiateCheckout2"]) {
            self.fb_st["InitiateCheckout2"] = FacebookEventApi.makeid(10);
            var xhr = new XMLHttpRequest();
            xhr.open("POST", `/api/fb-event/post-data/${self.pixel}/InitiateCheckout`, true);
            xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4 && xhr.status === 200) {
                    var r = JSON.parse(xhr.responseText);
                    setCookie(`fb_InitiateCheckout2${self.pixel}`, self.fb_st["InitiateCheckout2"], EXPIRES_DAY);
                    console.log("PX ATC OK " + self.fb_st["InitiateCheckout2"]);
                    try {
                        fbq('track', 'InitiateCheckout', '', {
                            eventID: self.fb_st["fb_InitiateCheckout2"]
                        });
                    } catch (e) {
                        console.log("InitiateCheckout fail");
                    }
                }
            };
            xhr.send(JSON.stringify({
                "fb-token": self.hash = hash,
                "domain": self.domain,
                "evend_id": self.fb_st["InitiateCheckout2"]
            }));
        } else {
            console.log("ARY ATC:" + c);
        }
    }

    self.callInitiateCheckout2 = function (callBack, content_ids, num_items, contents_quantity, value, content_category = "ALL", currency = "TWD") {
        var post_data = {
            content_ids: [content_ids],
            content_category: content_category,
            contents: [{
                'id': content_ids,
                'quantity': contents_quantity
            }],
            value: value,
            num_items: num_items,
            currency: currency
        };
        try {
            postConvert("Purchase", post_data);
        } catch (e) {
            console.log("Purchase2 error catch");
        }
    }

    self.callAddPaymentInfo = function () {
        var c = getCookie(`fb_AddPaymentInfo2${self.pixel}`);
        if (!c && !self.fb_st["AddPaymentInfo2"]) {
            self.fb_st["AddPaymentInfo2"] = FacebookEventApi.makeid(10);
            var xhr = new XMLHttpRequest();
            xhr.open("POST", `/api0/api/fb-event/post-data/${self.pixel}/AddPaymentInfo`, true);
            xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4 && xhr.status === 200) {
                    var r = JSON.parse(xhr.responseText);
                    setCookie(`fb_AddPaymentInfo2${self.pixel}`, self.fb_st["AddPaymentInfo2"], EXPIRES_DAY);
                    console.log("PX ATC OK " + self.fb_st["AddPaymentInfo2"]);
                    try {
                        fbq('track', 'AddPaymentInfo', '', {
                            eventID: self.fb_st["fb_AddPaymentInfo2"]
                        });
                    } catch (e) {
                        console.log("AddPaymentInfo fail");
                    }
                }
            };
            xhr.send(JSON.stringify({
                "fb-token": self.hash = hash,
                "domain": self.domain,
                "evend_id": self.fb_st["AddPaymentInfo2"]
            }));
        } else {
            console.log("ARY ATC:" + c);
        }
    }
    self.callAddPaymentInfo2 = function (em, phone, fn, external_id,fbclid){
        var post_data = {
            em: em,
            phone: phone,
            fn: fn,
            external_id: external_id,
            fbclid: fbclid
        }
        try {
            postConvert("AddPaymentInfo",post_data);
        } catch (e) {
            console.log("AddPaymentInfo2 error catch");
        }
    }
    FacebookEventApi.makeid = function (length) {
        var result = '';
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!_#$%^&*';
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() *
                charactersLength));
        }
        return result;
    }

    self.init = function (pixel) {
        if (!window.fbq) {
            var script = document.createElement("script");
            script.innerHTML = `   !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '${pixel}');
        `;
            document.head.appendChild(script);
            var noscript1 = document.createElement("noscript");
            noscript1.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${pixel}&ev=PageView&noscript=1"/>`;
            document.body.appendChild(noscript1);
        }
    }
    self.init(pixel);
}

module.exports = FacebookEventApi;
